import * as tslib_1 from "tslib";
import { EventEmitter, OnChanges, } from "@angular/core";
import { remove } from "lodash";
/**
 * TODO:
 * This will need to be a wrapper around specific question types
 * Should probably implement ControlValueAccessor for use as a form control
 * https://coryrylan.com/blog/angular-custom-form-controls-with-reactive-forms-and-ngmodel
 */
var QuestionComponent = /** @class */ (function () {
    function QuestionComponent() {
        this.selectedChoices = [];
        this.displayChoices = [];
        this.alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        this.tf = "TF";
        this.choiceEvent = new EventEmitter();
    }
    Object.defineProperty(QuestionComponent.prototype, "question", {
        get: function () {
            return this.questionData;
        },
        set: function (question) {
            this.questionData = question;
            this.selectedChoices = [];
            // this.choiceForm.nativeElement.reset();
        },
        enumerable: true,
        configurable: true
    });
    QuestionComponent.prototype.ngOnChanges = function () {
        var _this = this;
        if (this.questionData) {
            this.displayChoices = this.questionData.choices.map(function (choice, i) {
                return {
                    index: _this.question.type === "mc" || _this.question.type === "mc_multi"
                        ? _this.alpha[i]
                        : _this.tf[i],
                    answerText: choice.text,
                    selected: false,
                    status: choice.status,
                    hidden: choice.hidden,
                };
            });
        }
    };
    QuestionComponent.prototype.allowMultiSelections = function () {
        return this.question.mcAnswer && this.question.mcAnswer.choices.length > 1;
    };
    QuestionComponent.prototype.isSelected = function (i) {
        return this.selectedChoices.indexOf(i) > -1;
    };
    QuestionComponent.prototype.setChoice = function (choice) {
        this.allowMultiSelections()
            ? this.setMultiAnswer(choice)
            : this.setSingleAnswer(choice);
        this.sendAnswer();
    };
    QuestionComponent.prototype.onEsAnswerItemSelected = function (evt) {
        this.setChoice(evt.detail.index);
    };
    QuestionComponent.prototype.maxSelections = function () {
        var choices = this.question.mcAnswer.choices;
        return this.question.enableAllThatApply
            ? false
            : this.selectedChoices.length === choices.length;
    };
    QuestionComponent.prototype.setMultiAnswer = function (choice) {
        if (this.isSelected(choice)) {
            remove(this.selectedChoices, function (selectedChoice) { return selectedChoice == choice; });
        }
        else if (!this.maxSelections()) {
            this.selectedChoices.push(choice + "");
        }
        this.setSelected();
    };
    QuestionComponent.prototype.setSelected = function () {
        var _this = this;
        this.displayChoices = this.displayChoices.map(function (c) {
            return tslib_1.__assign({}, c, { selected: _this.isSelected(c.index) });
        });
    };
    QuestionComponent.prototype.setSingleAnswer = function (choice) {
        this.selectedChoices = [choice + ""];
        this.setSelected();
    };
    QuestionComponent.prototype.sendAnswer = function () {
        var _this = this;
        this.choiceEvent.emit(this.selectedChoices.map(function (c) {
            return _this.question.type === "mc" || _this.question.type === "mc_multi"
                ? _this.alpha.indexOf(c) + ""
                : _this.tf.indexOf(c) + "";
        }));
    };
    return QuestionComponent;
}());
export { QuestionComponent };
